import { CustomColorPallet } from '@barboxx/utils';

import { GlassColors, GlassVariant, IconBackGroundColors } from './types';

interface Props {
    variant?: GlassVariant;
    color?: GlassColors;
    background?: IconBackGroundColors;
    size?: number;
}

export const LogoIcon = (props: Props) => {
    const {
        variant = 'solid',
        background = 'transparent',
        color = 'white',
        size = 185,
    } = props;

    function getColors() {
        let glassColor: string;
        let fillColor: string;

        switch (color) {
            case 'primary':
                glassColor = CustomColorPallet.logoColors.teal;
                fillColor = CustomColorPallet.logoColors.teal;
                break;
            case 'gray':
                glassColor = CustomColorPallet.logoColors.gray;
                fillColor = CustomColorPallet.logoColors.gray;
                break;
            case 'white':
            default:
                glassColor = CustomColorPallet.logoColors.white;
                fillColor = CustomColorPallet.logoColors.white;
                break;
        }

        if (variant === 'fill') {
            switch (color) {
                case 'primary':
                    fillColor = CustomColorPallet.logoColors.white;
                    break;
                case 'gray':
                    fillColor = CustomColorPallet.logoColors.teal;
                    break;
                case 'white':
                    fillColor = CustomColorPallet.logoColors.teal;
                    break;
            }
        }

        return {
            fillColor,
            glassColor,
        };
    }
    const { fillColor, glassColor } = getColors();
    const backgroundColor =
        background === 'primary'
            ? CustomColorPallet.logoColors.teal
            : background;

    if (background === 'transparent') {
        return <GlassIcon variant={variant} size={size} color={color} />;
    }

    return (
        <svg width={size} height={size} viewBox="0 0 185 185" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 185H185V0H0V185Z"
                fill={backgroundColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M136 47.819C124.065 59.6076 112.081 71.4421 100.378 83C88.3138 71.0433 75.9104 58.7473 64 46.9434C65.9 47.5714 68.6107 48.5448 71.369 49.3638C79.1326 51.6711 86.7867 50.8857 94.4855 48.7617C100.745 47.0351 107.074 45.4398 113.468 44.3366C120.279 43.16 131.465 45.2473 136 47.819Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M99.2595 104L32 36.4943L38.472 30L99.2595 91.0113L146.529 43.5672L153 50.0615L99.2595 104Z"
                fill={glassColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97 185H102V97H97V185Z"
                fill={glassColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M110 95C110 100.523 105.523 105 100 105C94.4773 105 90 100.523 90 95C90 89.4773 94.4773 85 100 85C105.523 85 110 89.4773 110 95Z"
                fill={glassColor}
            />
        </svg>
    );
};

interface GlassProps {
    variant?: GlassVariant;
    color?: GlassColors;
    size?: number;
}

function GlassIcon({
    variant = 'solid',
    color = 'white',
    size = 155,
}: GlassProps) {
    function getColors() {
        let glassColor: string;
        let fillColor: string;

        switch (color) {
            case 'primary':
                glassColor = CustomColorPallet.logoColors.teal;
                fillColor = CustomColorPallet.logoColors.teal;
                break;
            case 'gray':
                glassColor = CustomColorPallet.logoColors.gray;
                fillColor = CustomColorPallet.logoColors.gray;
                break;
            case 'white':
            default:
                glassColor = CustomColorPallet.logoColors.white;
                fillColor = CustomColorPallet.logoColors.white;
                break;
        }

        if (variant === 'fill') {
            switch (color) {
                case 'primary':
                    fillColor = CustomColorPallet.logoColors.white;
                    break;
                case 'gray':
                    fillColor = CustomColorPallet.logoColors.teal;
                    break;
                case 'white':
                    fillColor = CustomColorPallet.logoColors.teal;
                    break;
            }
        }

        return {
            fillColor,
            glassColor,
        };
    }
    const { fillColor, glassColor } = getColors();

    const width = (121 / 155) * size;

    return (
        <svg width={width} height={size} viewBox="0 0 121 155" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M104 17.819C92.065 29.6076 80.0806 41.4421 68.3783 53C56.3138 41.0433 43.9104 28.7473 32 16.9434C33.9 17.5714 36.6107 18.5448 39.369 19.3638C47.1326 21.6711 54.7867 20.8857 62.4855 18.7617C68.7451 17.0351 75.0739 15.4398 81.4675 14.3366C88.2788 13.16 99.4648 15.2473 104 17.819Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M67.2595 74L0 6.49434L6.47204 0L67.2595 61.0113L114.529 13.5672L121 20.0615L67.2595 74Z"
                fill={glassColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65 155H70V67H65V155Z"
                fill={glassColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M78 65C78 70.5227 73.5227 75 68 75C62.4773 75 58 70.5227 58 65C58 59.4773 62.4773 55 68 55C73.5227 55 78 59.4773 78 65Z"
                fill={glassColor}
            />
        </svg>
    );
}
